import React, { useMemo } from "react";

const countryPoints = {
  Bangladesh: { x: 650, y: 210 },
  India: { x: 620, y: 215 },
  Pakistan: { x: 590, y: 205 },
  "United States": { x: 190, y: 170 },
  "United States of America": { x: 190, y: 170 },
  Canada: { x: 180, y: 115 },
  "United Kingdom": { x: 390, y: 145 },
  Germany: { x: 425, y: 155 },
  France: { x: 405, y: 165 },
  Italy: { x: 430, y: 185 },
  Spain: { x: 390, y: 185 },
  Australia: { x: 710, y: 285 },
  Japan: { x: 730, y: 190 },
  China: { x: 660, y: 180 },
  Malaysia: { x: 660, y: 245 },
  Singapore: { x: 665, y: 255 },
  "United Arab Emirates": { x: 555, y: 210 },
  "Saudi Arabia": { x: 525, y: 215 },
  Qatar: { x: 545, y: 215 },
};

function getField(item, keys, fallback = "") {
  for (const key of keys) {
    if (item?.[key] !== undefined && item?.[key] !== null && item?.[key] !== "") {
      return item[key];
    }
  }
  return fallback;
}

function normalizeCountry(country) {
  const value = String(country || "").trim();

  if (!value || value.toLowerCase() === "null") return "Unknown";

  const aliases = {
    USA: "United States",
    US: "United States",
    "United States of America": "United States",
    UK: "United Kingdom",
    UAE: "United Arab Emirates",
  };

  return aliases[value] || value;
}

function AdminWorldMap({ visitors = [] }) {
  const countryData = useMemo(() => {
    const counts = {};

    visitors.forEach((visitor) => {
      const country = normalizeCountry(
        getField(visitor, ["country", "country_name", "visitor_country"], "Unknown")
      );

      if (country !== "Unknown") {
        counts[country] = (counts[country] || 0) + 1;
      }
    });

    const list = Object.entries(counts)
      .map(([country, total]) => ({ country, total }))
      .sort((a, b) => b.total - a.total);

    const max = list.length ? list[0].total : 1;

    return { counts, list, max };
  }, [visitors]);

  return (
    <div className="mc-world-map-card">
      <div className="mc-world-map-wrap">
        <svg viewBox="0 0 900 420" role="img" aria-label="Visitor world map">
          <rect width="900" height="420" rx="18" className="mc-map-bg" />

          {/* Simplified world land shapes */}
          <path
            className="mc-map-land"
            d="M105 120 C145 80 220 80 270 115 C310 145 285 210 240 220 C185 235 145 210 115 180 C90 155 78 140 105 120Z"
          />
          <path
            className="mc-map-land"
            d="M245 220 C285 230 315 270 300 315 C285 360 225 360 195 325 C165 292 180 240 245 220Z"
          />
          <path
            className="mc-map-land"
            d="M365 120 C420 82 500 95 530 135 C565 180 525 220 455 215 C385 210 330 165 365 120Z"
          />
          <path
            className="mc-map-land"
            d="M470 220 C520 210 570 245 585 295 C600 350 555 375 510 350 C465 325 430 245 470 220Z"
          />
          <path
            className="mc-map-land"
            d="M555 145 C620 105 745 120 790 165 C835 210 785 260 700 250 C610 240 505 195 555 145Z"
          />
          <path
            className="mc-map-land"
            d="M675 275 C725 255 790 270 805 315 C820 360 760 380 710 355 C660 330 635 295 675 275Z"
          />

          {/* Visitor points */}
          {countryData.list.map((item) => {
            const point = countryPoints[item.country];
            if (!point) return null;

            const size = 7 + Math.min(16, (item.total / countryData.max) * 16);

            return (
              <g key={item.country}>
                <circle
                  cx={point.x}
                  cy={point.y}
                  r={size + 8}
                  className="mc-map-dot-glow"
                />
                <circle
                  cx={point.x}
                  cy={point.y}
                  r={size}
                  className="mc-map-dot"
                />
                <title>
                  {item.country}: {item.total} visitor{item.total === 1 ? "" : "s"}
                </title>
              </g>
            );
          })}
        </svg>
      </div>

      <div className="mc-world-map-list">
        <div className="mc-world-map-title">
          <span>Top Countries</span>
          <strong>{visitors.length} visits</strong>
        </div>

        {countryData.list.length ? (
          countryData.list.slice(0, 6).map((item) => (
            <div className="mc-world-country-row" key={item.country}>
              <span>{item.country}</span>
              <strong>{item.total}</strong>
            </div>
          ))
        ) : (
          <div className="mc-world-empty">
            No country data yet. Visitor countries will appear after GeoIP tracking is active.
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminWorldMap;